import {ReactElement} from 'react';
import Loading from './Loading';
import NoItems, {
  IProps as INoItemsProps,
} from '../../commonSub/component/NoItems';
import NoLogin, {
  IProps as INoLoginProps,
} from '../../commonSub/component/NoLogin';

interface IProps {
  showLoading?: boolean;
  showNoLogin?: boolean;
  showNoItems?: boolean;
  noLoginProps?: INoLoginProps;
  noItemsProps?: INoItemsProps;
  children: ReactElement;
}

export default function FetchResultWrapper({
  showLoading,
  showNoLogin,
  showNoItems,
  noLoginProps,
  noItemsProps,
  children,
}: IProps) {
  if (showNoLogin && noLoginProps) {
    return <NoLogin textClassName="leading-24" {...noLoginProps} />;
  }

  if (showLoading) {
    return <Loading isFull />;
  }

  if (showNoItems && noItemsProps) {
    return <NoItems className="leading-24" {...noItemsProps} />;
  }

  return children;
}
